import { NICmsContentField } from '@icms/core/content';

export const SeasonalProductsFields: NICmsContentField.IField[] = [
    {
        key: 'blockProductTitle',
        type: NICmsContentField.EFieldType.label,
        title: 'Product blocking configuration',
        group: 'Settings'
    },
    {
        key: 'blockedProducts',
        type: NICmsContentField.EFieldType.textarea,
        title: 'Blocker products ids',
        description: 'Enter the product ids you want to block, separated by commas`',
        group: 'Settings'
    },
    {
        key: 'whitelistedGroups',
        type: NICmsContentField.EFieldType.textarea,
        title: 'Whitelisted customer groups',
        description: 'Enter the customer groups you want to exclude from blocking, separated by commas`',
        group: 'Settings'
    }
];

export interface ISeasonalFields {
    // blocked product ids
    blockedProducts: string;
    // whitelisted customer groups
    whitelistedGroups: string;
}
